import dataApi from '../'

export default {

  // Get User object
  authLogin (params, redirect) {
    var authorizationHash = window.btoa(params.username + ':' + params.password)

    return dataApi.request({
      method: 'post',
      url: 'ui/auth/login',
      authorization: false,
      headers: {
        'Authorization': 'Basic ' + authorizationHash
      }
    })
  },

  /**
   * Method to perform auth using MFA.
   * @param {JSON} params
   * @returns response that contains the JWT tokens that will be used in auth header.
   */
  authLoginMfa (mfaRequest) {
    return dataApi.request({
      method: 'post',
      url: 'ui/v2/validate-mfa-token',
      authorization: false,
      body: mfaRequest

    })
  },

  /**
   * Gets the QR image for MFA pairing and the secret for manual pairing.
   * @param {string} username
   * @param {string} mfaTemporalToken
   * @returns The image in ArrayBuffer format: [10, 150, 19] in the body and mfa secret in header 'pragma'.
   */
  requestQrPairingMfa (mfaTemporalToken) {
    return dataApi.request({
      method: 'get',
      url: 'ui/v2/qr-code-pairing',
      authorization: false,
      accept: 'image/png',
      responseType: 'arraybuffer',
      headers: {
        'Temporal-Jwt': mfaTemporalToken
      }
    })
  },

  /**
   * Gets organization MFA settings.
   * @param {string} username
   * @param {string} mfaTemporalToken
   * @returns
   */
  getOrganizationMfaSettings (mfaTemporalToken) {
    return dataApi.request({
      method: 'get',
      url: 'ui/v2/mfa-settings',
      authorization: false,
      headers: {
        'Temporal-Jwt': mfaTemporalToken
      }
    })
  },

  logout (refreshToken) {
    return dataApi.request({
      method: 'post',
      url: 'ui/auth/logout',
      skipRefresh: true,
      body: {refreshToken}
    })
  },
  forgotPassword (id) {
    return dataApi.request({
      method: 'post',
      url: 'ui/auth/forgotPassword',
      authorization: false,
      body: id
    })
  },
  resetPassword (params, id, token) {
    return dataApi.request({
      method: 'post',
      url: 'ui/auth/resetPassword/' + id + '/' + token,
      authorization: false,
      body: params
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/auth.js